<template>

    <div class="c-form_inline">
        <slot></slot>
    </div>

</template>


<script>
export default {
    name: 'FormInline'
}
</script>


<style lang="scss">

.c-form_inline {
    display: flex;

    & > div {
        flex-grow: 999;
        margin: 0 5px;

        &:last-child {
            margin-right: 0;
        }
        &:first-child {
            margin-left: 0;
        }
    }
}

</style>
